import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faAngleDown,
  faArrowRight,
  faArrowUp,
  faComment,
  faHeadset,
  faStar,
} from '@fortawesome/free-solid-svg-icons';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { Subject } from 'rxjs/internal/Subject';
import { AccountType_v2 } from '../../../models/app-enums';
import { HelperService } from '../../../services/helper.service';
import { MetaService } from '../../../services/meta.service';
import { MixpanelService } from '../../../services/mixpanel.service';
import { ResizeService } from '../../../services/resize.service';
import { BannerComponent } from './components/banner/banner.component';
import { NgxLiteYoutubeModule } from 'ngx-lite-video'
@Component({
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    CarouselModule,
    LazyLoadImageModule,
    RouterModule,
    BannerComponent,
    NgxLiteYoutubeModule,
  ],
  selector: 'app-becomeacreator',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit, OnDestroy {
  carouselDataInput: any = [];
  userAccountTypes = AccountType_v2;
  faAngleDown = faAngleDown;
  faUsers = faHeadset;
  faComment = faComment;
  faStar = faStar;
  faArrowUp = faArrowUp;
  faArrowRight = faArrowRight;
  showPlaybackControls = false;
  scrollPosition: number = 0;
  dataLoaded: boolean = false;
  loader: boolean = false;
  private destroy$ = new Subject<void>();

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 2000,
    nav: false,
    items: 2,
    lazyLoad: true,
  };

  customOptions2: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    navText: ['', ''],
    nav: false,
    margin: 20,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },

  }

  slidesStore = [
    {
      imgUrl: "https://res.cloudinary.com/dmdawjgs8/image/upload/v1732713901/pmh1svjpdjt1oprgb80n.webp",
      fname: "Bernarr",
      lname: "Dominik",
      title: "Career Consultant",
      left: false,
      small: false,
    },
    {
      imgUrl: "https://res.cloudinary.com/dmdawjgs8/image/upload/v1732779459/oydi3ddz5megao5psgjb.webp",
      fname: "Alex",
      lname: "Stanger",
      title: "Branding Expert",
      left: true,
      small: false,
    },
    {
      
      imgUrl: "https://res.cloudinary.com/dmdawjgs8/image/upload/v1732778900/hgbhodxihuvnidmldb3q.webp",
      fname: "Antonia",
      lname: "Brownstein",
      title: "Wellness Advocate",
      left: false,
      small: false,
    },
    {
      imgUrl: "https://res.cloudinary.com/dmdawjgs8/image/upload/v1732777809/fzb6emsazot7nvydguqm.webp",
      fname: "Fabian",
      lname: "Capmany",
      title: "Developer",
      left: true,
      small: true,
    }
  ]

  reviews=[
    {
      imgUrl: "https://res.cloudinary.com/dmdawjgs8/image/upload/v1732714009/wyaka1dfewv9zfzmh6r9.webp",
      name: "Wade Warren",
      title: "Growth Strategist",
      review: "Connecting with my audience has never felt more meaningful.",
      themeColor: "#FFF9D0",
      left: true,
    },
    {
      imgUrl: "https://res.cloudinary.com/dmdawjgs8/image/upload/v1732777740/vbj6cgyd4hp2wsnox8bx.webp",
      name: "Darlene Robertson",
      title: "Content Creator",
      review: "Sharing my ideas has turned into an opportunity to inspire and grow.",
      themeColor: "#FFF9D0",
      left: true
    },
    {
      imgUrl: "https://res.cloudinary.com/dmdawjgs8/image/upload/v1732777723/sljob0vsbwj7soxaexsi.webp",
      name: "Jenny Wilson",
      title: "Marketing Guru",
      review: "Engaging with my community now feels effortless and impactful.",
      themeColor: "#FFF9D0",
      left: true
    },
    {
      imgUrl: "https://res.cloudinary.com/dmdawjgs8/image/upload/v1732777701/xszzkz7czy1yok9jdmj0.webp",
      name: "Guy Hawkins",
      title: "Business Mentor",
      review: "Building deeper connections has transformed the way I approach my work.",
      themeColor: "#FFF9D0",
      left: true
    },
  ]

  waysCards:any = [
    {
      imgUrl: 'https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575669/Archive/way1_a7zud5.png',
      videoUrl: '',
      title: 'Paid Calls',
      subTitle: 'Have real-time, one-on-one video calls with your audience to share insights, advice, or exclusive content',
    },
    {
      imgUrl: 'https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575668/Archive/way2_riblrn.png',
      videoUrl: '',
      title: 'Paid Chats',
      subTitle: 'Offer personalized guidance through direct messaging, answering questions and providing tailored support',
    },
    {
      imgUrl: 'https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575670/Archive/way3_rdhdgd.png',
      videoUrl: '',
      title: 'Mega Sessions',
      subTitle: 'Connect with a larger audience from around the world through interactive group sessions, discussions, workshops, and Q&A’s',
    },
    {
      imgUrl: 'https://res.cloudinary.com/dmdawjgs8/image/upload/v1740995264/wpo1otdl5oefkrjss7th.webp',
      videoUrl: '',
      title: 'Monthly Subscriptions',
      subTitle: 'Earn reliable monthly subscriptions from your dedicated fans. Unlock exclusive interactions, build loyalty, and monetize your creative passion with your fans.',
    }
  ];

  constructor(
    private mix: MixpanelService,
    public resize: ResizeService,
    private metaService: MetaService,
    public helper: HelperService,
  ) {
    this.mix.trackPageVisit(null, null, null, null, null);
  }

  ngOnInit(): void {
    this.updateMetaTags();
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isAppleDevice(): boolean {
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera;
    return /iPhone|iPod|iPad/i.test(userAgent);
  }

  isAndroidDevice(): boolean {
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera;
    return /Android/i.test(userAgent);
  }
  updateMetaTags() {
    const title =
      'Join Mentoga as a Creator: Empower Your Career & Connect with Fans';
    const description =
      'Become a Mentoga creator and take your creative career to the next level. Connect directly with your fans, monetize your expertise, and build a loyal community. Start your journey today.';
    const ogUrl = window.location.href;
    this.metaService.updateMetaTags(
      title,
      description,
      null,
      title,
      description,
      ogUrl,
    );
  }
}
